import { StyleSheet, css } from 'aphrodite'
import React, { type FC } from 'react'

const UpdateToast: FC = () => {
  const handleRefresh = () => {
    console.log(
      '%c[Preserve Log] Service Worker: Update requested',
      'color: #31C48D',
    )
    console.log(
      '%c[Preserve Log] Service Worker: Reloading application to apply updates...',
      'color: #31C48D',
    )

    // Store time for after refresh
    sessionStorage.setItem('sw_update_time', new Date().toISOString())
    window.location.reload()
  }

  React.useEffect(() => {
    const updateTime = sessionStorage.getItem('sw_update_time')
    if (updateTime) {
      console.log(
        `%c[Preserve Log] Service Worker: Update completed at ${updateTime}`,
        'color: #31C48D',
      )
      sessionStorage.removeItem('sw_update_time')
    }
  }, [])

  return (
    <button onClick={handleRefresh} className={css(styles.container)}>
      <div className={css(styles.content)}>
        <span className={css(styles.title)}>New content available</span>
        <span className={css(styles.subtitle)}>
          Click to refresh and see the latest updates
        </span>
      </div>
      <div className={css(styles.iconContainer)}>
        <i className="fa-solid fa-arrows-rotate" />
      </div>
    </button>
  )
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '18px 20px',
    gap: '16px',
    minWidth: '380px',
    maxWidth: '420px',
    background: 'linear-gradient(135deg, #1e293b 0%, #1a1f2e 100%)',
    border: '1px solid rgba(99, 102, 241, 0.3)',
    boxShadow:
      '0px 8px 24px rgba(0, 0, 0, 0.25), 0px 2px 8px rgba(99, 102, 241, 0.15)',
    borderRadius: '12px',
    cursor: 'pointer',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    ':hover': {
      transform: 'translateY(-2px)',
      boxShadow:
        '0px 12px 32px rgba(0, 0, 0, 0.3), 0px 4px 12px rgba(99, 102, 241, 0.25)',
      borderColor: 'rgba(99, 102, 241, 0.5)',
    },
    ':active': {
      transform: 'translateY(0px)',
    },
  },
  iconContainer: {
    width: '40px',
    height: '40px',
    background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)',
    borderRadius: '10px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#ffffff',
    fontSize: '18px',
    flexShrink: 0,
    boxShadow: '0px 4px 12px rgba(99, 102, 241, 0.3)',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '6px',
    flex: 1,
  },
  title: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '15px',
    lineHeight: '140%',
    color: '#f1f5f9',
    letterSpacing: '-0.01em',
  },
  subtitle: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '13px',
    lineHeight: '150%',
    color: '#cbd5e1',
    letterSpacing: '-0.005em',
  },
})

export default UpdateToast
